import { render, staticRenderFns } from "./select-secondary.vue?vue&type=template&id=69caea8a&scoped=true"
import script from "./select-secondary.vue?vue&type=script&lang=js"
export * from "./select-secondary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69caea8a",
  null
  
)

export default component.exports